
export default function Contact(){
  
  const click= ()=>{
     alert("Thanks for submitting: We will Contact soon");
     
   }
    return(
        <>
        <div className="maincontact">
            <div className="head "> 
            <h1 >Contact us</h1> 
        <h4>By submitting your Information</h4></div>
       
        <form className="form ">
  <div class="row mb-4">
    <div class="col">
      <div class="form-outline">
      <label class="form-label" for="form6Example1">First name</label>
        <input type="text" id="form6Example1" class="form-control" />
        
      </div>
    </div>
    <div class="col">
      <div class="form-outline">
      <label class="form-label" for="form6Example2">Last  name</label>
        <input type="text" id="form6Example2" class="form-control" />
        
      </div>
    </div>
  </div>

  <div class="form-outline mb-4">
  <label class="form-label" for="form6Example5">Email</label>
    <input type="email" id="form6Example5" class="form-control" />
   
  </div>
  <div class="form-outline mb-4">
  <label class="form-label" for="form6Example4">Address</label>
    <input type="text" id="form6Example4" class="form-control" />
    
  </div>

  
  <div class="form-outline mb-4">
  <label class="form-label" for="form6Example6">Phone</label>
    <input type="number" id="form6Example6" class="form-control" />
    
  </div>

  
  <div class="form-outline mb-4">
  <label class="form-label" for="form6Example7">Additional information</label>
    <textarea class="form-control" id="form6Example7" rows="6"></textarea>
   
  </div>
<div className="text-center">
<button type="submit" class="btn btn-primary btn-block mb-4 " onClick={click} >Submit Information</button>

</div>
</form>

        </div>
       
        </>
    );
    
}